import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';

interface ItfItem {
    name: string;
    text: string;
}
const Tab1: React.FC = () => {
    const { t } = useLang('stream.overview');
    const items: ItfItem[] = [
        {
            name: t('H_item1_list1_name'),
            text: t('H_item1_list1_text'),
        },
        {
            name: t('H_item1_list2_name'),
            text: t('H_item1_list2_text'),
        },
        {
            name: t('H_item1_list3_name'),
            text: t('H_item1_list3_text'),
        },
        {
            name: t('H_item1_list4_name'),
            text: t('H_item1_list4_text'),
        },
    ];

    return (
        <div className={`${css.frag}`}>
            <EcoImg
                className="tab1-img"
                pc="https://websiteoss.ecoflow.com/upload/image/1774595445173/h1.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1774595445173/h1.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1774595445614/h1m.jpg"
                alt={t.rich('H_item1_name', {
                    y: (tx: string) => tx,
                    b: (tx: string) => tx,
                })}
            />
            <div className="img-info">
                <p className="name">
                    {t.rich('H_item1_name', {
                        y: (tx: string) => <span className="y">{tx}</span>,
                        b: (tx: string) => <span className="b">{tx}</span>,
                    })}
                </p>
                {/* <p className="text">
                    {t.rich('H_item1_text', {
                        w: (tx: string) => <span className="w">{tx}</span>,
                    })}
                </p> */}
                <ul className="items">
                    {items?.map((item: ItfItem, i: number) => (
                        <li className="item" key={i}>
                            <p className="item-name">{item.name}</p>
                            <p className="item-text">{item.text}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default Tab1;
